import { Capacitor, registerPlugin } from '@capacitor/core';

/**
 * Ask iOS for the App Store rating sheet.
 *
 * Fired after scorecards post successfully — the one moment the product has
 * just visibly done its job. iOS decides whether the sheet really appears
 * (Apple caps prompts at ~3 a year and shows none on TestFlight builds), so
 * this needs no throttling of its own; the plugin resolves either way and a
 * missing plugin (web, Android shell) is simply a no-op.
 */
interface RequestReviewPlugin {
  request(): Promise<void>;
}

const RequestReview = registerPlugin<RequestReviewPlugin>('RequestReview');

export async function maybeRequestReview(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await RequestReview.request();
  } catch {
    // Not registered on this platform — nothing to do.
  }
}
